module.exports = __webpack_public_path__ + "img/bg.4176e27e.png";